const baseApiUrl = 'https:/jajka.softwarepizza.com/';

export default baseApiUrl;
